import { useEffect } from 'react';
import { session, type AccessCheck, type PurposeOfUse } from '@/api';

/** Follow the latest access decision, including a grant ended before its first read settled. */
export function useChartPurpose(access: AccessCheck | undefined, normalPurpose: PurposeOfUse) {
  useEffect(() => {
    if (!access) return;
    const emergency = !!access.activeBreakGlass;
    const previous = session.get().purpose;
    if (emergency) session.setContext({ purpose: 'EMERGENCY' });
    else if (previous === 'EMERGENCY') session.setContext({ purpose: normalPurpose });
    return () => {
      if (emergency) session.setContext({ purpose: previous === 'EMERGENCY' ? normalPurpose : previous });
    };
  }, [access, normalPurpose]);
}
